import blueMountain from '../images/IMG_5617.jpeg';
import washingtonPass from '../images/washingtonpass.jpg';
import hurricaneRidge from '../images/IMG_4064.jpeg';


export const SCENICOVERLOOKS = [
    {
        id: 0,
        title: 'Blue Mountain',
        description: 'Fairly steep and narrow dirt road up to an overlook, small hiking trail, and a campground.',
        googleMaps: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2458.7751379744404!2d-123.26480752534633!3d47.95501495893253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548fc96780a991bf%3A0x908c19d86fa3b9ae!2sBlue%20Mountain%20Trail%20Head!5e0!3m2!1sen!2sus!4v1765434481250!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        image: blueMountain,
        location: 'Port Angeles, WA',
        dateVisited: '12/10/25',
        favorite: false,
        kindOfPlace: 'overlook'
    },
    {
        id: 1,
        title: 'Washington Pass',
        description: 'Found on the way while driving out to Eastern Washington. Not worth the drive on it own but a good place to stop.',
        googleMaps: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10569.995160724715!2d-120.65454489095248!3d48.523672102486884!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5484ac608cb63cd5%3A0x4dae50e7a914b394!2sWashington%20Pass!5e0!3m2!1sen!2sus!4v1765434875002!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        image: washingtonPass,
        location: 'Gilbert, WA',
        dateVisited: '12/10/25',
        favorite: false,
        kindOfPlace: 'overlook'
    },
    {
        id: 2,
        title: 'Hurricane Ridge',
        description: 'Relatively short drive from Port Angeles. Central hub for othe roads, skiing, and hiking.',
        googleMaps: '<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10692.666807174724!2d-123.4199265317025!3d47.93315906618985!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548e352bd0a99893%3A0x6535f1684ce8b755!2sHurricane%20Ridge!5e0!3m2!1sen!2sus!4v1765435166641!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>',
        image: hurricaneRidge,
        location: 'Port Angeles, WA',
        dateVisited: '12/10/25',
        favorite: false,
        kindOfPlace: 'overlook'
    }
]